import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import {
  buildImpactReportDeferredBody,
  IMPACT_REPORT_DEFERRED_GENERIC_BODY,
  IMPACT_REPORT_DEFERRED_TITLE,
} from "@/constants/impactReport";

interface ImpactReportDeferredStateProps {
  /** Who the report will be emailed to. Unknown on the emailed link's own page. */
  recipient?: string | null;
}

/**
 * A deferred report still being built. Never an empty state and never an error: the report is
 * coming, by email and on this page once the job completes.
 */
export function ImpactReportDeferredState({ recipient }: ImpactReportDeferredStateProps) {
  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        minHeight: "400px",
        gap: 1.5,
      }}
    >
      <CircularProgress sx={{ color: "var(--color-dark-dust)" }} />
      <Typography sx={{ fontSize: "18px", fontWeight: 700, color: "var(--color-rodeo-black)" }}>
        {IMPACT_REPORT_DEFERRED_TITLE}
      </Typography>
      <Typography sx={{ fontSize: "14px", color: "var(--color-graphite)", maxWidth: "420px" }}>
        {recipient ? buildImpactReportDeferredBody(recipient) : IMPACT_REPORT_DEFERRED_GENERIC_BODY}
      </Typography>
    </Box>
  );
}
